(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Luna-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-luna-just-landed]';

    document.addEventListener('shopify:section:load', (event) => {
      const namespace = window.LunaJustLandedCarousel;
      if (!namespace) return;

      if (event.target.matches?.(selector)) namespace.init(event.target);
      event.target.querySelectorAll?.(selector).forEach(namespace.init);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(selector).forEach((carousel) => carousel.lunaCarouselCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["echoes-of-astra-landing"] && !Shopify.designMode) return;
  try {
    
  const initEchoesLanding = (root) => {
    if (!root || root.dataset.echoesReady === 'true') return;
    root.dataset.echoesReady = 'true';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const reveals = [...root.querySelectorAll('.eo-reveal')];

    if (!reducedMotion && 'IntersectionObserver' in window) {
      root.classList.add('is-motion-ready');
      const revealObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
      );
      reveals.forEach((element) => revealObserver.observe(element));
    } else {
      reveals.forEach((element) => element.classList.add('is-visible'));
    }

    root.querySelectorAll('.eo-video-card').forEach((card) => {
      const video = card.querySelector('.eo-video');
      const button = card.querySelector('.eo-video__control');
      const label = button?.querySelector('span');
      if (!video || !button || !label) return;

      const updateButton = () => {
        const isPaused = video.paused;
        const nextLabel = isPaused ? button.dataset.labelPlay : button.dataset.labelPause;
        label.textContent = nextLabel;
        button.setAttribute('aria-label', nextLabel);
      };

      if (reducedMotion) {
        video.pause();
        video.dataset.userPaused = 'true';
        updateButton();
      }

      button.addEventListener('click', () => {
        if (video.paused) {
          video.dataset.userPaused = 'false';
          video.play().catch(() => {});
        } else {
          video.dataset.userPaused = 'true';
          video.pause();
        }
        updateButton();
      });

      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);

      if (!reducedMotion && 'IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting && video.dataset.userPaused !== 'true') {
              video.play().catch(() => {});
            } else if (!entry.isIntersecting) {
              video.pause();
            }
          },
          { threshold: 0.35 }
        );
        videoObserver.observe(video);
      }
    });

    root.querySelectorAll('a[href^="#eo-"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        const move = () => target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        if (!reducedMotion && document.startViewTransition) {
          document.startViewTransition(move);
        } else {
          move();
        }
      });
    });
  };

  document.querySelectorAll('[data-echoes-section]').forEach(initEchoesLanding);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-echoes-section]');
    initEchoesLanding(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luna-event-calendar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('luna-event-calendar')) {
    class LunaEventCalendar extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.weekMilliseconds = 7 * 24 * 60 * 60 * 1000;
        this.locale = this.dataset.locale || document.documentElement.lang || 'en-AU';
        this.eventTimeZone = this.dataset.eventTimezone || 'Australia/Sydney';
        this.eventTitle = this.dataset.eventTitle || '';
        this.startParts = this.parseStart();
        this.nextIndex = this.nextOccurrenceIndex();
        this.selectedIndex = this.nextIndex;
        const selectedDate = this.occurrenceAt(this.selectedIndex);
        this.visibleMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
        this.previousButton = this.querySelector('[data-calendar-previous]');
        this.nextButton = this.querySelector('[data-calendar-next]');
        this.previousButton.addEventListener('click', () => this.changeMonth(-1));
        this.nextButton.addEventListener('click', () => this.changeMonth(1));
        this.renderWeekdays();
        this.render();
      }

      parseStart() {
        const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(this.dataset.startDate || '2026-10-26');
        const timeMatch = /^(\d{2}):(\d{2})$/.exec(this.dataset.startTime || '18:30');
        return {
          year: Number(dateMatch ? dateMatch[1] : 2026),
          month: Number(dateMatch ? dateMatch[2] : 10),
          day: Number(dateMatch ? dateMatch[3] : 26),
          hour: Number(timeMatch ? timeMatch[1] : 18),
          minute: Number(timeMatch ? timeMatch[2] : 30),
        };
      }

      partsInZone(date, timeZone) {
        const formatter = new Intl.DateTimeFormat('en-CA', {
          timeZone: timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23',
        });
        const values = {};
        formatter.formatToParts(date).forEach((part) => {
          if (part.type !== 'literal') values[part.type] = Number(part.value);
        });
        return values;
      }

      zonedDateToUtc(year, month, day, hour, minute) {
        const intended = Date.UTC(year, month - 1, day, hour, minute, 0);
        let candidate = intended;
        for (let attempt = 0; attempt < 3; attempt += 1) {
          const parts = this.partsInZone(new Date(candidate), this.eventTimeZone);
          const represented = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second || 0);
          candidate -= represented - intended;
        }
        return new Date(candidate);
      }

      occurrenceAt(index) {
        const dateOnly = new Date(Date.UTC(this.startParts.year, this.startParts.month - 1, this.startParts.day + index * 7, 12));
        return this.zonedDateToUtc(
          dateOnly.getUTCFullYear(),
          dateOnly.getUTCMonth() + 1,
          dateOnly.getUTCDate(),
          this.startParts.hour,
          this.startParts.minute
        );
      }

      nextOccurrenceIndex() {
        const now = Date.now();
        const first = this.occurrenceAt(0).getTime();
        if (now <= first) return 0;
        let index = Math.max(0, Math.floor((now - first) / this.weekMilliseconds));
        while (this.occurrenceAt(index).getTime() < now) index += 1;
        while (index > 0 && this.occurrenceAt(index - 1).getTime() >= now) index -= 1;
        return index;
      }

      localDateKey(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return year + '-' + month + '-' + day;
      }

      renderWeekdays() {
        const container = this.querySelector('[data-calendar-weekdays]');
        const monday = new Date(2024, 0, 1, 12);
        const formatter = new Intl.DateTimeFormat(this.locale, { weekday: 'short' });
        container.replaceChildren();
        for (let index = 0; index < 7; index += 1) {
          const day = new Date(monday);
          day.setDate(monday.getDate() + index);
          const label = document.createElement('div');
          label.className = 'll-events__weekday';
          label.setAttribute('role', 'columnheader');
          label.textContent = formatter.format(day);
          container.append(label);
        }
      }

      changeMonth(offset) {
        this.visibleMonth = new Date(this.visibleMonth.getFullYear(), this.visibleMonth.getMonth() + offset, 1);
        this.renderCalendar();
      }

      render() {
        this.renderCalendar();
        this.renderDetails(this.selectedIndex);
        const localZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const notice = this.querySelector('[data-timezone-notice]');
        if (notice && localZone) notice.textContent = notice.textContent + ' ' + localZone;
      }

      renderCalendar() {
        const monthLabel = this.querySelector('[data-month-label]');
        monthLabel.textContent = new Intl.DateTimeFormat(this.locale, { month: 'long', year: 'numeric' }).format(this.visibleMonth);

        const firstDay = new Date(this.visibleMonth.getFullYear(), this.visibleMonth.getMonth(), 1, 12);
        const mondayOffset = (firstDay.getDay() + 6) % 7;
        const gridStart = new Date(firstDay);
        gridStart.setDate(firstDay.getDate() - mondayOffset);
        const gridEnd = new Date(gridStart);
        gridEnd.setDate(gridStart.getDate() + 42);

        const firstOccurrence = this.occurrenceAt(0).getTime();
        let startIndex = Math.floor((gridStart.getTime() - firstOccurrence) / this.weekMilliseconds) - 2;
        let endIndex = Math.ceil((gridEnd.getTime() - firstOccurrence) / this.weekMilliseconds) + 2;
        startIndex = Math.max(0, startIndex);
        endIndex = Math.max(startIndex, endIndex);

        const eventsByDate = new Map();
        for (let index = startIndex; index <= endIndex; index += 1) {
          const occurrence = this.occurrenceAt(index);
          const key = this.localDateKey(occurrence);
          eventsByDate.set(key, { date: occurrence, index: index });
        }

        const days = this.querySelector('[data-calendar-days]');
        days.replaceChildren();
        const todayKey = this.localDateKey(new Date());
        const timeFormatter = new Intl.DateTimeFormat(this.locale, { hour: 'numeric', minute: '2-digit' });
        const fullFormatter = new Intl.DateTimeFormat(this.locale, {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          timeZoneName: 'short',
        });

        for (let offset = 0; offset < 42; offset += 1) {
          const date = new Date(gridStart);
          date.setDate(gridStart.getDate() + offset);
          const key = this.localDateKey(date);
          const event = eventsByDate.get(key);
          const cell = document.createElement('div');
          cell.className = 'll-events__day';
          cell.setAttribute('role', 'gridcell');
          if (date.getMonth() !== this.visibleMonth.getMonth()) cell.classList.add('ll-events__day--outside');
          if (key === todayKey) {
            cell.classList.add('ll-events__day--today');
            cell.setAttribute('aria-current', 'date');
          }

          const number = document.createElement('span');
          number.className = 'll-events__date-number';
          number.textContent = String(date.getDate());
          cell.append(number);

          if (event) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'll-events__event';
            button.textContent = timeFormatter.format(event.date);
            button.setAttribute('aria-label', this.eventTitle + ', ' + fullFormatter.format(event.date));
            button.setAttribute('aria-pressed', event.index === this.selectedIndex ? 'true' : 'false');
            button.addEventListener('click', () => {
              this.selectedIndex = event.index;
              this.renderCalendar();
              this.renderDetails(event.index);
            });
            cell.append(button);
          }
          days.append(cell);
        }
      }

      renderDetails(index) {
        const eventDate = this.occurrenceAt(index);
        const dateText = new Intl.DateTimeFormat(this.locale, {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        }).format(eventDate);
        const hostText = new Intl.DateTimeFormat('en-AU', {
          timeZone: this.eventTimeZone,
          hour: 'numeric',
          minute: '2-digit',
          timeZoneName: 'short',
        }).format(eventDate);
        const localText = new Intl.DateTimeFormat(this.locale, {
          hour: 'numeric',
          minute: '2-digit',
          timeZoneName: 'short',
        }).format(eventDate);
        const localZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
        this.querySelector('[data-event-date]').textContent = dateText;
        this.querySelector('[data-host-time]').textContent = hostText;
        this.querySelector('[data-local-time]').textContent = localText;
        this.querySelector('[data-local-zone]').textContent = localZone;
        this.querySelector('[data-event-kicker]').textContent =
          index === this.nextIndex ? this.dataset.labelNextEvent : this.dataset.labelSelectedEvent;
      }
    }

    customElements.define('luna-event-calendar', LunaEventCalendar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
